<template>
  <DrawerVue :refreshDisplay="refreshDisplay" v-if="userData">
    <v-form ref="addressForm">
      <v-container fluid class="mt-4">
        <v-row class="mb-4">
          <v-col>
            <h2>{{ $t("basics.edit", { type: $t("basics.email") }) }}</h2>
            <p>{{ userData.email }}</p>
          </v-col>
        </v-row>

        <v-row class="mb-6">
          <v-col cols="12">
            <p v-html='$t("messages.mailChangeProcedure")'></p>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field variant="outlined" :rules="[max256, validEmailRule, requiredRule]"
              v-model="newEmail" :label="$t('basics.email') + '*'"></v-text-field>
          </v-col>
        </v-row>


        <v-row>
          <v-col>
            <v-btn large block flat class="primaryButton" @click="confirm()" ref="confirmButton">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </DrawerVue>
</template>

<script>
export default {
  name: "addressDrawerComponent",

  props: {
    userData: { required: true }
  },

  emits: ["close", "refresh"],

  watch: {
    refreshDisplay(){
      this.newEmail = undefined
    }
  },

  data() {
    return {
      newEmail: undefined,

      validEmailRule: (value) =>
        !value || /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value) || this.$i18n.t("messages.wrongEMailFormat"),
      requiredRule: (value) => (value !== undefined) || this.$i18n.t("messages.required"),
      max256: (value) =>
        !value || value.length <= 256 || this.$i18n.t("messages.tooLong", { count: 256 }),
    };
  },

  components: {
  },

  watch: {
  },

  methods: {
    async confirm() {
      const { valid } = await this.$refs.addressForm.validate();

      if (valid) {
        let formData = {
          new_email: this.newEmail,
          id: this.userData.id
        };

        this.patchData(formData);
      }
    },
    patchData(formData) {
      this.axios
        .patch(this.axios.defaults.baseURL + "user/users/patch/" + formData.id, formData)
        .then((resp) => {
          this.$emit("close", 1);
          this.$emit("refresh", 1);
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },
};
</script>
